export default {
  attachment_picker_button_tooltip: 'Chat tools',
};
